import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SettingsStateService {
  private settingsStatusSubject = new Subject<any>();

  constructor() { }

  triggerSettingsStatus(data: any) {
    this.settingsStatusSubject.next(data);
  }

  handleSettingsStatus(): Observable<any> {
    return this.settingsStatusSubject.asObservable();
  }

}




// WEBPACK FOOTER //
// ./src/app/components/dashboard/settings/settings.state.service.ts